// Per-company role derivation for /hallinta gating + the company picker.
// The betonijerry FE has NO companyRoles; it has flat asiakasPersonSettings rows.
const ADMIN_TYPE_IDS = new Set([2, 22]);        // asiakasAdmin, asiakasOwner
const EDIT_TYPE_IDS = new Set([1, 2, 5, 6, 22]); // tarjousAdmin, asiakasAdmin, laskuAdmin, editor, owner

function settingsFor(user, asiakasId) {
  return (user?.asiakasPersonSettings || []).filter(
    (s) => Number(s.asiakasId) === Number(asiakasId) && s.boolVar !== false
  );
}

export function tierOn(user, asiakasId) {
  if (!user || asiakasId == null) return null;
  const types = settingsFor(user, asiakasId).map((s) => Number(s.asiakasPersonSettingTypeId));
  if (types.some((t) => ADMIN_TYPE_IDS.has(t))) return "admin";
  if (types.some((t) => EDIT_TYPE_IDS.has(t))) return "edit";
  return null;
}

export function isAdminOn(user, asiakasId) {
  return tierOn(user, asiakasId) === "admin";
}

export function deriveCompanies(user) {
  return (user?.asiakasList || [])
    .filter((a) => Number(a.asiakasTypeId) === 1)
    .map((a) => ({ ...a, tier: tierOn(user, a.asiakasId) }));
}

export function eligibleCompanies(user) {
  return deriveCompanies(user).filter((c) => c.tier === "admin" || c.tier === "edit");
}
